import { UserRole } from 'app/core/interfaces/login.interface';

/**
 * Maps a UserRole to its i18n translation key under `common.roles.*`.
 * Used by the users module to render the translated role label via @ngx-translate.
 * The legacy `USER_ROLE_LABEL_ES` constant is preserved for other modules.
 */
export const USER_ROLE_LABEL_KEY: Record<UserRole, string> = {
  [UserRole.Owner]: 'common.roles.owner',
  [UserRole.Administrator]: 'common.roles.administrator',
  [UserRole.Operator]: 'common.roles.operator',
  [UserRole.Manager]: 'common.roles.manager',
};
